export type TranslateFn = (key: string) => string

export const localizeConfig = <T>(value: T, translate: TranslateFn): T => {
	if (typeof value === 'string') {
		return (translate(value) || value) as T
	}

	if (Array.isArray(value)) {
		return value.map((item) => localizeConfig(item, translate)) as T
	}

	if (value && typeof value === 'object') {
		return Object.fromEntries(
			Object.entries(value as Record<string, unknown>).map(([key, item]) => [key, localizeConfig(item, translate)])
		) as T
	}

	return value
}